import React from 'react';

import Col from 'react-bootstrap/Col';
import InlineEditorWrapper from '../../utilities/InlineEditorWrapper';
import ListView from '../shared/lists/ListView';
import NameFranchiseEditor from '../shared/editors/NameFranchiseEditor';
import NameFranchiseItem from '../shared/editors/NameFranchiseItem';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import UseSearch from '../../utilities/useFilter';

const SubLeadSourceList = (props) => {
    const getUrl = '/api/lookups/list';
    const editUrl = '/api/lookups/SubLeadSource/edit/';
    const postUrl = '/api/lookups/SubLeadSource/edit';
    const deleteUrl = '/api/lookups/SubLeadSource/delete';

    const { items, setData, submitFilter, pageInfo } =
        UseSearch(getUrl, { lookupType: 'SubLeadSource', leadSourceIds: [props.id] }, true);

    const canAdd = items.filter(i => i.id === 0).length === 0;

    function addNew() {
        const currentItems = JSON.parse(JSON.stringify(items));
        if (canAdd) {
            currentItems.push({ id: 0 });
            setData(currentItems);
        }
    }

    const tableHead = (
        <thead className="table-index-subhead font-weight-normal">
            <tr>
                <SortableTh content="Sub Lead Sources" sort={pageInfo} sortName="Name" />
                <SortableTh width={100} content="External" sort={pageInfo} sortName="ExternallyVisible" />
                <SortableTh className="two-button-cell" />
            </tr>
        </thead>
    );

    const sources = items.map((item) =>
        <InlineEditorWrapper
            editItem={props.editItem}
            isNew={item.id === 0}
            key={item.id}
        >
            <NameFranchiseItem
                deleteUrl={deleteUrl}
                fetchData={submitFilter}
                item={item}
                showExternal={true}
            />
            <NameFranchiseEditor
                cancelEdit={submitFilter}
                fetchData={submitFilter}
                getUrl={editUrl + item.id + '?leadSourceId=' + props.id}
                postUrl={postUrl}
                showExternal={true}
            />
        </InlineEditorWrapper>
    );

    return (
        <Row>
            <Col>
                <ListView
                    addItem={addNew}
                    canAdd={canAdd}
                    itemName="Sub Lead Source"
                    items={sources}
                    tableHead={tableHead}
                />
                <Row className="mt-4">
                    <Col>
                        <PagedListControl {...pageInfo} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default SubLeadSourceList;